import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Input } from '@/components/shadcn/input'
import { BaseFieldProps } from './types'
import clsx from 'clsx'
import { DocumentationButton } from './DocumentationButton'

export const FileField: React.FC<BaseFieldProps> = ({ field, formFieldName, control }) => {
  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => (
        <FormItem className={clsx('flex flex-1 flex-col', field.widget === 'hidden' && 'hidden')}>
          <div className="flex justify-start gap-2">
            <FormLabel>{field.title}</FormLabel>
            <DocumentationButton documentation={field.documentation} />
          </div>
          <FormDescription className="text-xs">{field.description}</FormDescription>
          <FormControl>
            <Input type="file" onChange={(e) => formField.onChange(e.target.files?.[0])} disabled={field.readOnly} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
